<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row align-v="center" class="mb-3">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i>
            VOLTAR
          </v-btn>
        </b-col>
        <b-col>
          <h1 class="title-pages">CONFIGURAÇÃO DOSSIÊ</h1>
        </b-col>
      </b-row>

      <b-overlay :show="loading" opacity="0.99">
        <!-- ── Seção: Configuração de campos para impressão ───── -->
        <b-card class="mb-3">
          <h6 class="title-pages mb-3">INFORMAÇÕES DO DOSSIÊ</h6>
          <p class="worksansr mb-3" style="font-size: 13px; color: #666">
            Defina quais seções aparecem por padrão no dossiê.
          </p>

          <div
            v-for="section in informations"
            :key="section.key"
            class="mb-1"
            style="
              border: 1px solid #e9ecef;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <!-- Cabeçalho da seção -->
            <div
              class="d-flex align-items-center px-3 py-2"
              style="background: #f8f9fa; border-bottom: 1px solid #e9ecef"
            >
              <input
                type="checkbox"
                :id="`ps-${section.key}`"
                v-model="section.selected"
                @change="handleSectionToggle(section)"
                style="
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                  accent-color: #4e9130;
                  flex-shrink: 0;
                "
              />
              <label
                :for="`ps-${section.key}`"
                class="worksansr mb-0 ml-2 flex-grow-1"
                style="
                  font-size: 14px;
                  font-weight: 600;
                  cursor: pointer;
                  color: #343a40;
                "
              >
                {{ section.label }}
              </label>

              <!-- Expandir campos — só se a seção tiver campos granulares -->
              <button
                v-if="section.fields && section.fields.length > 0"
                type="button"
                @click="section.expanded = !section.expanded"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  color: #6c757d;
                  padding: 0 4px;
                  font-size: 12px;
                  display: flex;
                  align-items: center;
                  gap: 4px;
                "
              >
                <span class="worksansr" style="font-size: 11px">
                  {{
                    section.expanded ? "ocultar campos" : "configurar campos"
                  }}
                </span>
                <i
                  :class="
                    section.expanded
                      ? 'fas fa-chevron-up'
                      : 'fas fa-chevron-down'
                  "
                ></i>
              </button>
            </div>

            <!-- Lista de campos -->
            <div
              v-if="
                section.expanded && section.fields && section.fields.length > 0
              "
            >
              <!-- Marcar / Desmarcar todos -->
              <div
                class="d-flex px-3 py-1"
                style="background: #fff; border-bottom: 1px solid #f1f1f1"
              >
                <button
                  type="button"
                  class="worksansr"
                  style="
                    background: none;
                    border: none;
                    padding: 0;
                    font-size: 11px;
                    color: #4e9130;
                    cursor: pointer;
                    margin-right: 12px;
                  "
                  @click="selectAllFields(section, true)"
                >
                  Marcar todos
                </button>
                <button
                  type="button"
                  class="worksansr"
                  style="
                    background: none;
                    border: none;
                    padding: 0;
                    font-size: 11px;
                    color: #dc3545;
                    cursor: pointer;
                  "
                  @click="selectAllFields(section, false)"
                >
                  Desmarcar todos
                </button>
              </div>

              <!-- Campos individuais -->
              <div
                v-for="field in section.fields"
                :key="field.key"
                class="d-flex align-items-center px-4 py-1"
                style="border-bottom: 1px solid #f8f9fa"
              >
                <input
                  type="checkbox"
                  :id="`pf-${section.key}-${field.key}`"
                  v-model="field.selected"
                  :disabled="!section.selected"
                  style="
                    width: 14px;
                    height: 14px;
                    cursor: pointer;
                    accent-color: #4e9130;
                    flex-shrink: 0;
                  "
                />
                <label
                  :for="`pf-${section.key}-${field.key}`"
                  class="worksansr mb-0 ml-2"
                  :style="{
                    fontSize: '13px',
                    cursor: section.selected ? 'pointer' : 'not-allowed',
                    color: section.selected ? '#495057' : '#adb5bd',
                  }"
                >
                  {{ field.label }}
                </label>
              </div>
            </div>
          </div>
        </b-card>

        <errors-messages :errors="errors" />

        <b-row align-h="end" class="mb-4">
          <b-col cols="auto">
            <confirmation-dialog
              message-title="CONFIRMAÇÃO"
              message-body="TEM CERTEZA QUE DESEJA SALVAR?"
              open-class="btn-save"
              open-text="SALVAR"
              openLeftIcon="fa-check"
              @yes="save"
            />
          </b-col>
        </b-row>
      </b-overlay>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";
import api from "../services/api";
import toast from "../lib/ToastNotification";

const DEFAULT_INFORMATIONS = [
  {
    key: "DossierTechnicalManager",
    label: "Responsável Técnico",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierLicense",
    label: "Alvará / Licença de Funcionamento",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierSanitaryLicense",
    label: "Licença Sanitária",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierSanitaryVisit",
    label: "Termo de Visita Sanitária",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierFireDept",
    label: "Certificado do Corpo de Bombeiros",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierElderlyCouncil",
    label: "Inscrição no Conselho Municipal da Pessoa Idosa (CMI / CMDPI)",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierWelfareCouncil",
    label: "Registro no Conselho Municipal de Assistência Social (CMAS)",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierWaterTank",
    label: "Limpeza dos Reservatórios de Água",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierWaterPotability",
    label: "Laudo de Potabilidade da Água",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierPestControl",
    label: "Controle de Pragas e Vetores",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierOutsourcing",
    label: "Terceirização de Serviços",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierHealthProviders",
    label: "Prestadores de Saúde",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierHRClt",
    label: "Recursos Humanos – Colaboradores CLT",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierInfrastructure",
    label: "Infraestrutura da ILPI",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierSOPs",
    label: "POPs – Procedimentos Operacionais Padrão",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierWorkSchedule",
    label: "Escalas de Trabalho",
    selected: true,
    expanded: false,
    fields: [],
  },
  {
    key: "DossierMenu",
    label: "Cardápios",
    selected: true,
    expanded: false,
    fields: [],
  },
];

export default {
  name: "ConfigDossier",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      loading: false,
      // Deep clone para não mutar o DEFAULT durante a sessão
      informations: JSON.parse(JSON.stringify(DEFAULT_INFORMATIONS)),
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      await this.get();
    },

    async get() {
      this.loading = true;
      try {
        const response = await api.get("/rest-home/settings/config-dossier");
        const { error, errors, informations } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          // Se o banco já tem configuração salva, faz merge com o padrão
          // O merge garante que campos novos adicionados futuramente apareçam
          if (informations) {
            let saved = JSON.parse(informations);

            // Se ainda for string após o primeiro parse, parseia novamente
            if (typeof saved === "string") {
              saved = JSON.parse(saved);
            }

            this.informations = this.mergeSections(DEFAULT_INFORMATIONS, saved);
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    /**
     * Merge entre a estrutura padrão (fonte da verdade de campos disponíveis)
     * e os valores salvos no banco (fonte da verdade de selected/expanded).
     * Assim, novos campos adicionados ao DEFAULT aparecem automaticamente
     * sem quebrar configurações já salvas.
     */
    mergeSections(defaults, saved) {
      return defaults.map((defaultSection) => {
        const savedSection = saved.find((s) => s.key === defaultSection.key);
        if (!savedSection) return { ...defaultSection };

        const mergedFields = defaultSection.fields.map((defaultField) => {
          const savedField = savedSection.fields
            ? savedSection.fields.find((f) => f.key === defaultField.key)
            : null;
          return savedField
            ? { ...defaultField, selected: savedField.selected }
            : { ...defaultField };
        });

        return {
          ...defaultSection,
          selected: savedSection.selected,
          expanded: false, // sempre começa recolhido
          fields: mergedFields,
        };
      });
    },

    async save() {
      try {
        this.loading = true;

        let { informations } = this;

        // Serializa só o necessário: key, selected e fields com key+selected
        const sectionsToSave = informations.map((s) => ({
          key: s.key,
          selected: s.selected,
          fields: s.fields
            ? s.fields.map((f) => ({ key: f.key, selected: f.selected }))
            : [],
        }));

        const data = {
          informations: JSON.stringify(sectionsToSave),
        };

        const response = await api.patch(
          "/rest-home/settings/config-dossier",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    handleSectionToggle(section) {
      if (!section.selected && section.fields) {
        section.fields.forEach((f) => {
          f.selected = false;
        });
      }
    },

    selectAllFields(section, value) {
      if (section.fields) {
        section.fields.forEach((f) => {
          f.selected = value;
        });
      }
    },
  },
};
</script>